import Header from "@/reusable_sections/Header";
import PageHero from "@/components/PageHero";
import ServiceIntro from "@/components/service/ServiceIntro";
import ServiceCards from "@/components/service/ServiceCards";
import BlockPavingQuote from "./sections/BlockPavingQuote";
import OtherServices from "@/components/service/OtherServices";
import CtaBand from "@/components/CtaBand";
import Footer from "@/reusable_sections/Footer";
import { BrickWall, Palette, Wrench } from "lucide-react";
const subServices = [{
  title: "Driveway Installation",
  description: "Precision-engineered block paving driveways built with excavated ground, geotextile membrane, compacted MOT Type 1 sub-base, and sharp sand bedding for lasting stability.",
  icon: BrickWall
}, {
  title: "Patio & Garden Spaces",
  description: "Custom outdoor entertaining areas and garden transitions installed with premium blocks, elegant border edging, and seamless surface levels.",
  icon: Palette
}, {
  title: "Pathways & Pedestrian Areas",
  description: "Safe, durable surfaces for front approaches, garden pathways, and pedestrian walkways across Southampton, Hampshire & surrounding areas.",
  icon: Wrench
}, {
  title: "Pattern & Design",
  description: "Bespoke herringbone (45° and 90°), stretcher bond, basketweave, and contemporary layout patterns with contrasting charcoal or kerb stone edging.",
  icon: Palette
}, {
  title: "Maintenance & Repair",
  description: "Comprehensive aftercare including kiln-dried sand re-jointing, sunken block levelling, specialist power washing, and protective surface sealing.",
  icon: Wrench
}];
export default function BlockPavingPage() {
  return <div className="min-h-screen bg-background text-foreground flex flex-col">
      <Header />

      <PageHero breadcrumbLabel="Block Paving" breadcrumbParent={{
      label: "Services",
      to: "/ServicesHubPage"
    }} eyebrow="OUR SERVICES" title="Block Paving in Southampton" intro="Transform your home with precision-engineered block paving driveways, patios, and pathways in Southampton, Hampshire & surrounding areas." imageSrc="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662274/img/block_paving_driveway.png" imageAlt="Block paving driveway installation in Southampton by Firststop Roofing Ltd" actions={true} />

      <ServiceIntro eyebrow="EXPERT PAVING & GROUNDWORKS" heading="Professional Block Paving & Driveway Services in Southampton" paragraphs={["Transform your property with our expert block paving in Southampton, delivering custom driveways, patios, and garden pathways built for lasting strength. As trusted roofing and property specialists in Southampton, we combine meticulous ground preparation with premium materials to create outdoor surfaces that elevate your kerb appeal.", "Every driveway installation is completed by Matt and our experienced team with excavated ground, geotextile membrane, deep compacted MOT Type 1 sub-bases, precision edge restraints, and kiln-dried silica sand jointing to guarantee structural integrity for everyday vehicle use across Southampton and Hampshire."]} benefits={["Bespoke herringbone, stretcher bond, and decorative pattern layouts", "Deep compacted MOT Type 1 sub-base for heavy vehicle loading", "Durable edge restraints and long-lasting weed-resistant jointing"]} imageSrc="https://qualityroofsandlandscapes.co.uk/wp-content/uploads/2026/05/block-paving-work.jpg?v=6jjtp1dpwgq" imageAlt="Block paving installation in Southampton completed by Firststop Roofing Ltd" cta={true} />

      <ServiceCards eyebrow="SPECIALIST SOLUTIONS" heading="Our Block Paving & Driveway Solutions" intro="Comprehensive block paving services tailored to enhance your property with expert craftsmanship in Southampton, Hampshire & surrounding areas." items={subServices} columns={3} />

      <BlockPavingQuote />

      <OtherServices currentKey="block-paving" />

      <CtaBand />

      <Footer />
    </div>;
}